var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoloansBc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.843,
    height: 99.258,
    viewBox: "0 0 107.843 99.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831",
    "data-name": "Rectangle 1831",
    width: 16.683,
    height: 15.088,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831-2",
    "data-name": "Rectangle 1831",
    width: 14.956,
    height: 13.526,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742",
    transform: "translate(-501.933 -142.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M34.162,0C17.918,0,5.225,8.1,1.067,20.2S4.9,54.618,25.263,56.622,56.462,42.394,76.632,45.1s19.2-20.7,5.227-30.716S50.406,0,34.162,0Z",
    transform: "matrix(-0.891, 0.454, -0.454, -0.891, 609.776, 199.48)",
    fill: "#e3f1dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(533.883 142.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735",
    transform: "translate(0 19.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734",
    transform: "translate(0 18.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M1.846-5.188,53.53-10a1.887,1.887,0,0,1,1.846,1.925V35.233a1.887,1.887,0,0,1-1.846,1.925H1.846A1.887,1.887,0,0,1,0,35.233v-38.5A1.887,1.887,0,0,1,1.846-5.188Z",
    transform: "translate(0 10)",
    fill: "#548943"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733",
    transform: "translate(0 5.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    "data-name": "Rectangle 1828",
    width: 57.744,
    height: 42.346,
    rx: 4,
    fill: "#bfdbb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    transform: "translate(1.925 1.925)",
    fill: "#bfdbb1",
    stroke: "#6c7c65",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.895,
    height: 38.496,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 53.395,
    height: 37.996,
    rx: 3.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1830",
    "data-name": "Rectangle 1830",
    d: "M3.85,0H17.323a0,0,0,0,1,0,0V7.7a0,0,0,0,1,0,0H3.85A3.85,3.85,0,0,1,0,3.85v0A3.85,3.85,0,0,1,3.85,0Z",
    transform: "translate(40.421 17.323)",
    fill: "#548943"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 2.406,
    cy: 2.406,
    rx: 2.406,
    ry: 2.406,
    transform: "translate(42.346 18.767)",
    fill: "#bfdbb1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M219.985,4428.856s2.765-10.138,13.035-10.006,13.005-1.012,15.931-6.056,5.566-7.031,9.617-6.563",
    transform: "translate(-200.263 -4406.164)",
    fill: "none",
    stroke: "#c8ccd2",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737",
    transform: "matrix(0.407, 0.914, -0.914, 0.407, 67.831, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M16.538,7.892a4.175,4.175,0,0,0-1.293-1.745c-.147-.126-.3-.242-.426-.34.2-.48.419-.929.569-1.4A3.6,3.6,0,0,0,14.707.692,1.754,1.754,0,0,0,12.135.461a5.693,5.693,0,0,0-1.157,1.4A18,18,0,0,0,9.353,5.576c-.021.064-.045.127-.075.215-.063-.11-.106-.2-.162-.277a6.278,6.278,0,0,0-.471-.635.385.385,0,0,1-.131-.272c-.01-.521-.025-1.042-.04-1.563-.007-.246-.14-.4-.342-.391s-.324.157-.319.408c.007.364.019.728.026,1.091,0,.156,0,.312,0,.478a1.105,1.105,0,0,0-.762.411c-.415-.275-.821-.545-1.228-.813a1.226,1.226,0,0,0-.2-.111.327.327,0,0,0-.444.2.347.347,0,0,0,.18.426c.44.3.883.593,1.321.895a.361.361,0,0,1,.117.172c.069.2.113.4.193.6a4.8,4.8,0,0,0,.275.495c-.364-.088-.682-.173-1-.242a18.716,18.716,0,0,0-3.338-.418,4.459,4.459,0,0,0-1.9.31A1.609,1.609,0,0,0,.007,8.237a3.23,3.23,0,0,0,1.037,2.148A4.344,4.344,0,0,0,3.36,11.45c.33.057.665.082,1,.122,0,.032.01.064.012.1a5.272,5.272,0,0,0,.47,1.9A2.6,2.6,0,0,0,6.17,14.893a2.826,2.826,0,0,0,1.438.172,2.682,2.682,0,0,0,1.927-.956,3.787,3.787,0,0,0,.6-1.056c.079-.209.145-.423.22-.644a1.141,1.141,0,0,0,1.939-1.072c.189.048.36.1.535.135a3.554,3.554,0,0,0,1.74,0,3.01,3.01,0,0,0,1.779-1.554,5.894,5.894,0,0,0,.336-.976V8.421c-.048-.177-.084-.358-.145-.529m-4.864,3.894a.459.459,0,0,1-.812.137,1.122,1.122,0,0,1-.075-.125Q9.208,8.942,7.632,6.087A3.041,3.041,0,0,1,7.5,5.763a.515.515,0,0,1,.327-.433.462.462,0,0,1,.5.135,1.121,1.121,0,0,1,.1.164q1.58,2.854,3.159,5.708a.532.532,0,0,1,.084.448",
    transform: "translate(0 0)",
    fill: "#faad14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M4.177,6.48a.459.459,0,0,1-.812.137,1.118,1.118,0,0,1-.075-.125Q1.711,3.637.135.782A3.042,3.042,0,0,1,0,.458.515.515,0,0,1,.327.025a.462.462,0,0,1,.5.135,1.12,1.12,0,0,1,.1.164q1.58,2.854,3.159,5.708a.532.532,0,0,1,.084.448",
    transform: "translate(7.497 5.305)",
    fill: "#be7f00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741",
    transform: "translate(25.841 8.803) rotate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736-2",
    "data-name": "Group 3736",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948-2",
    "data-name": "Path 1948",
    d: "M14.826,7.075a3.742,3.742,0,0,0-1.159-1.564c-.132-.113-.271-.217-.382-.3.177-.43.376-.833.51-1.256A3.224,3.224,0,0,0,13.185.62,1.572,1.572,0,0,0,10.879.413,5.1,5.1,0,0,0,9.842,1.666,16.138,16.138,0,0,0,8.385,5c-.019.058-.04.114-.067.192-.057-.1-.1-.177-.145-.248a5.628,5.628,0,0,0-.422-.569.345.345,0,0,1-.117-.244c-.009-.467-.022-.934-.036-1.4-.006-.221-.126-.356-.306-.35s-.29.141-.286.366c.006.326.017.652.023.978,0,.14,0,.28,0,.428a.991.991,0,0,0-.683.368l-1.1-.729a1.1,1.1,0,0,0-.177-.1.293.293,0,0,0-.4.183.311.311,0,0,0,.162.382c.394.268.792.532,1.184.8a.324.324,0,0,1,.1.155c.062.177.1.362.173.535a4.3,4.3,0,0,0,.246.443c-.326-.079-.612-.155-.9-.217A16.779,16.779,0,0,0,2.648,5.6a4,4,0,0,0-1.7.278A1.443,1.443,0,0,0,.006,7.384,2.9,2.9,0,0,0,.936,9.31a3.894,3.894,0,0,0,2.076.955c.3.051.6.074.9.109,0,.029.009.057.011.086a4.726,4.726,0,0,0,.421,1.7,2.334,2.334,0,0,0,1.191,1.189,2.533,2.533,0,0,0,1.289.154,2.4,2.4,0,0,0,1.728-.857,3.4,3.4,0,0,0,.538-.947c.071-.187.13-.379.2-.577a1.023,1.023,0,0,0,1.738-.961c.169.043.323.09.48.121a3.186,3.186,0,0,0,1.56,0,2.7,2.7,0,0,0,1.595-1.393,5.284,5.284,0,0,0,.3-.875V7.549c-.043-.158-.075-.321-.13-.474m-4.36,3.491a.412.412,0,0,1-.728.123,1,1,0,0,1-.067-.112Q8.255,8.017,6.842,5.457a2.726,2.726,0,0,1-.121-.29.462.462,0,0,1,.293-.388.414.414,0,0,1,.45.121,1,1,0,0,1,.094.147q1.417,2.558,2.832,5.117a.477.477,0,0,1,.075.4",
    transform: "translate(0 0)",
    fill: "#faad14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949-2",
    "data-name": "Path 1949",
    d: "M3.745,5.809a.412.412,0,0,1-.728.123,1,1,0,0,1-.067-.112Q1.534,3.261.121.7A2.726,2.726,0,0,1,0,.41.462.462,0,0,1,.293.023a.414.414,0,0,1,.45.121A1,1,0,0,1,.838.291L3.67,5.408a.477.477,0,0,1,.075.4",
    transform: "translate(6.721 4.756)",
    fill: "#be7f00"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoloansBc);
export default __webpack_public_path__ + "static/media/noloans-bc.29ec9614d739cd5ada5490f1b2cce419.svg";
export { ForwardRef as ReactComponent };